import {EntityBase} from "../../../shared/entity/EntityBase";
import dayjs from "dayjs";

const BADGE_MASTER_FIELDS = {
    seq: { type: Number, defaultValue: 0 },
    index: { type: Number, defaultValue: 0 },
    name: { defaultValue: '' },
    begin: { type: Number, defaultValue: dayjs().hour(9).startOf('hour').unix() },
    end: { type: Number, defaultValue: dayjs().add(1, 'day').hour(8).endOf('hour').unix() },
    onOff: { type: Number, defaultValue: 0 }, // 0: off, 1: on
}

export class BadgeMasterEntity extends EntityBase {
    constructor(data = {}) {
        super(data, BADGE_MASTER_FIELDS);

        this.errors = [
            {condition: () => this.index === 0, message: '인덱스가 없습니다.'},
        ];
    }
}